import { useState, useLayoutEffect } from 'react'
import { Box } from '@mui/material'
import { useStyles } from './styles'
import { PropsTableSelect } from './props'
import { CrudTableWithFilter } from '../../../../../../components'

export const SelectTables = (props: PropsTableSelect) => {
  const [donstRefresh, setDonstRefresh] = useState(false)
  const styles = useStyles()

  useLayoutEffect(() => {
    setDonstRefresh(false)
  }, [props.table])

  return (
    <Box sx={styles.filterContainer}>
      <CrudTableWithFilter
        dontRefresh={donstRefresh}
        tableChecks
        tableRadio={true}
        customSelected={-1}
        colors={props.colors}
        withoutPadding
        textBig
        hidden={{
          informativeCard: true,
          add: true,
        }}
        defaultChecks={props.defaultChecks}
        setInformation={(e) => {
          setDonstRefresh(true)
          props.handleInformation(e)
        }}
        isLoading={props.isLoading}
        filterComponent={{
          title: props.header.title,
          filterTitle: props.t('schedule.filter.filterTitle'),
          type: 4,
          right:props.right,
          top:props.top,
        }}
        filterDescription={{
          filter: {
            name: 'search',
            label: props.header.search,
          },
        }}
        tableData={props.table}
        initialFilterData={props.initialFilterValues}
        filterRow={props.filterRow}
      />
    </Box>
  )
}
